import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-62',
  templateUrl: './cards10-examples-62.component.html'
})
export class Cards10Examples62Component {}
